import React, { Component } from 'react';
import { connect } from 'react-redux';
import { END_TO_END_CHANNEL } from '../../../constants/treeConstants';
import {
  getAMISignalList,
  getAdsSignalMap,
  getContrAndDeviceInfo
} from '../../../services/Andes_v2/endToEndChannel/AMIModelHelper';
import AMIModelRender from '../AMIModel';
import { updateADSConfig } from '../store/endToEndChannel/action';

class AMIModel extends Component {
  constructor(props) {
    super(props);
    this.state = {
      controllerInfo: null,
      deviceInfo: null
    }
  }

  componentDidMount = async () => {
    const { adsConfig, pcbConnections = [], connections = [] } = this.props;
    const {
      controllerInfo,
      deviceInfo,
      contrPCBIndex,
      devicePCBIndex,
      controllerICComps,
      deviceICComps
    } = await getContrAndDeviceInfo({ config: adsConfig, pcbConnections, connections });

    this.setState({
      controllerInfo,
      deviceInfo,
      contrPCBIndex,
      devicePCBIndex,
      controllerICComps,
      deviceICComps
    })
  }

  render() {
    const { adsConfig = {}, pcbConnections = [], connections = [], serdesType } = this.props;
    const { controllerInfo, deviceInfo, controllerICComps, deviceICComps, contrPCBIndex, devicePCBIndex } = this.state;
    const signal_map = getAdsSignalMap({ pcbConnections, connections });
    const adsSignals = getAMISignalList({ adsConfig, controllerInfo, deviceInfo, signal_map, pcbConnections, connections, serdesType });

    return <AMIModelRender
      {...this.props}
      adsSignals={adsSignals}
      signal_map={signal_map}
      contrPCBIndex={contrPCBIndex}
      devicePCBIndex={devicePCBIndex}
      controllerInfo={controllerInfo}
      deviceInfo={deviceInfo}
      controllerICComps={controllerICComps}
      deviceICComps={deviceICComps}
      interfaceType={END_TO_END_CHANNEL}
      adsConfig={adsConfig}
      selectedSignals={adsSignals.map(item => item.signal)}
      adsAllSignals={adsSignals}
    />
  }
}

const mapState = (state) => {
  const {
    endToEndChannel: { endToEndChannelInfo: { content = {}, adsConfig, id, type } }
  } = state.AndesV2Reducer;
  const {
    pcbConnections = [],
    connections = []
  } = content;

  return {
    adsConfig,
    pcbConnections,
    connections,
    endToEndId: id,
    serdesType: type
  }
}

const mapDispatch = (dispatch) => ({
  _updateADSConfig(adsConfig, options) {
    dispatch(updateADSConfig(adsConfig, options))
  }
})

export default connect(mapState, mapDispatch)(AMIModel);